import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  saveButton: {
    color: theme.palette.error.main,
    font: "normal normal normal 12px/15px Helvetica",
    letterSpacing: "0px",
    opacity: 1,
    height: "25px",
    width: "59px",
    marginLeft: "5px",
  },
  progress: {
    color: theme.palette.error.main,
  },
}))

export default styles
